import { CSSObject } from '@chakra-ui/react';

export const BadgeCountdown = (
  state: 'inprogress' | 'prior' | 'ended'
): CSSObject => ({
  '&&&&': {
    bg: () => {
      if (state === 'inprogress') {
        return 'alpha.100';
      }
      if (state === 'ended') {
        return 'red.500';
      }
      // 'prior'
      return 'alpha.700';
    },
    color: () => {
      if (state === 'inprogress') {
        return 'alpha.600';
      }
      if (state === 'ended') {
        return 'white';
      }
      // 'prior'
      return 'beta.500';
    },
    borderRadius: 'sm',
    px: 1,
    fontFamily: 'roboto',
    fontWeight: 'bold',
  },
  '&&': {
    h: '16px',
    maxH: '16px',
    minH: '16px',
    lineHeight: '16px',
  },
});
